import {
  fetchZoneAction,
  fetchFieldsAction,
  saveZoneAction,
  updateZoneAction,
  quickRunAction,
  multipleQuickRunAction,
} from './actions';

const getZones = (dispatch) => (payload) => dispatch(fetchZoneAction(payload));

const getFields = (dispatch) => () => dispatch(fetchFieldsAction());

const saveZone = (dispatch) => (payload) => dispatch(saveZoneAction(payload));

const updateZone = (dispatch) => (payload) => dispatch(updateZoneAction(payload));

const quickRun = (dispatch) => (payload) => dispatch(quickRunAction(payload));

const multipleQuickRun = (dispatch) => (payload) => dispatch(multipleQuickRunAction(payload));

const operations = {
  getZones,
  getFields,
  saveZone,
  updateZone,
  quickRun,
  multipleQuickRun,
};

export default operations;
